import { useCallback as e, useMemo as t } from "react";
//#region src/hooks/useInfiniteList.ts
function n(e, t) {
	return e?.pages.flatMap((e) => e[t]) ?? [];
}
function r(r, i) {
	let { data: a, hasNextPage: o, isFetchingNextPage: s, fetchNextPage: c } = r, l = t(() => n(a, i), [a, i]), u = e(() => {
		o && !s && c();
	}, [
		o,
		s,
		c
	]);
	return {
		...r,
		items: l,
		onEndReached: u
	};
}
//#endregion
export { n as flattenInfinitePages, r as useInfiniteList };
